















import Vue from 'vue';
import { Editor, EditorContent } from 'tiptap';
import {
  Blockquote,
  Bold,
  BulletList,
  CodeBlockHighlight,
  Heading,
  ListItem,
  Strike,
  Placeholder,
  Link,
  TrailingNode,
  History,
  Collaboration,
} from 'tiptap-extensions';
import { CustomDoc as Doc } from '@/components/editor/Doc';
import { Title } from '@/components/editor/Title';
import editorConfig from '@/config/editor';
import { findTextNodes } from 'prosemirror-utils';

import { db } from '@/db/firestore';

export default Vue.extend({
  components: {
    EditorContent,
  },
  props: {
    noteid: String,
    thumbnail: Boolean,
    editable: Boolean,
    nosave: Boolean,
  },
  data(): {
    editor: any;
    defaultExtensions: () => any[];
    hasFocus: boolean;
  } {
    return {
      editor: null,
      defaultExtensions: editorConfig.defaultExtensions,
      hasFocus: false,
    };
  },
  computed: {
    localNoteVersion(): number {
      return this.$store.state.localNoteVersion;
    },
    note(): any {
      return this.$store.state.note;
    },
    masterNoteVersion(): number {
      return (this.note || {}).version;
    },
    steps(): any[] {
      return (this.note || {}).steps;
    },
  },
  watch: {
    editable() {
      if (this.editor === null) {
        return;
      }
      this.editor.setOptions({
        editable: this.editable,
      });
    },
    masterNoteVersion() {
      if (this.editor === null) {
        return;
      }
      if (this.localNoteVersion < this.masterNoteVersion) {
        const updateData = {
          version: this.masterNoteVersion,
          steps: this.steps
            .filter((step: any) => {
              return step.version > this.localNoteVersion;
            })
            .map((step: any) => {
              return Object.assign(step, { step: JSON.parse(step.step) });
            }),
        };
        // console.log('updateData', updateData);
        this.editor.extensions.options.collaboration.update(updateData);
        this.$store.state.localNoteVersion = this.masterNoteVersion;
      }
    },
  },
  methods: {
    getJSON() {
      return this.editor.getJSON();
    },
    onInit({ doc, version }: { doc: any; version: number }) {
      this.editor = new Editor({
        autoFocus: true,
        editable: this.editable,
        content: doc,
        extensions: [
          ...this.defaultExtensions(),
          new TrailingNode({
            node: 'paragraph',
            notAfter: ['paragraph'],
          }),
          new Placeholder({
            showOnlyCurrent: false,
            emptyNodeText: (node: any) => {
              if (node.type.name === 'title') {
                return 'タイトル';
              }
              return '';
            },
          }),
          new History(),
          new Collaboration({
            version,
            debounce: 1000,
            onSendable: ({ sendable }: { sendable: any }) => {
              if (this.nosave) {
                return;
              }
              // console.log('sendable', sendable);
              this.$store
                .dispatch(
                  'transactionalUpdateNote',
                  Object.assign(sendable, { doc: this.getJSON() }),
                )
                .catch((err) => {
                  console.log('Error:', err);
                });
            },
          }),
        ],
        onFocus: () => {
          this.hasFocus = true;
        },
        onBlur: () => {
          this.hasFocus = false;
        },
      });
    },
  },
  async created() {
    await this.$store.dispatch('bindNote', { id: this.noteid });
    await this.$store.dispatch('bindNoteRef', { id: this.noteid }); // TODO: Fix
    this.$store.state.localNoteVersion = this.$store.state.note.version;
    this.onInit({
      doc: JSON.parse(this.note.doc),
      version: this.$store.state.localNoteVersion,
    });
  },
  mounted() {},
  beforeDestroy() {
    this.editor.destroy();
  },
});
